import type { PurchaserConfigTemplate } from "@src/domain/entities/purchaser";
import type { IPurchaserRepository } from "@src/domain/repositories/purchaser";
import type { UpdatePurchaserConfigTemplateDTO } from "@src/domain/dto/purchasers";

export class UpdatePurchaserConfigTemplateUseCase {
  private readonly purchaserRepository: IPurchaserRepository;

  constructor(purchaserRepository: IPurchaserRepository) {
    this.purchaserRepository = purchaserRepository;
  }

  execute(
    params: UpdatePurchaserConfigTemplateDTO,
  ): Promise<PurchaserConfigTemplate> {
    return this.purchaserRepository.updatePurchaserConfigTemplate(params);
  }
}
